import { html, css, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { IColor, IProduct } from './IProduct';
import { ViewerMode } from './enums';
import Swiper from 'swiper';
import { EffectFade, Navigation, Pagination, Thumbs } from 'swiper/modules';
import { waitForElementToExist } from '../../shared';
import mediaSliderCss from 'bundle-text:./../../assets/css/media-slider.css';

export class MediaSlider extends LitElement {
  @property({ type: Object }) color: IColor | undefined;
  @property({ type: String }) viewerMode: ViewerMode | undefined;
  @property({ type: Boolean }) isTileHover: Boolean | undefined;
  swiper: Swiper | undefined;
  swiperThumbs: Swiper | undefined;
  @state() currentColor: IColor | undefined;
  swiperActiveIndex: number = 0;

  constructor() {
    super();
  }

  updated(changedProperties: Map<string, unknown>) {
    if (changedProperties.has("color")) {

      if (!this.color) {
        return;
      }

      this.currentColor = this.color;

      if (this.viewerMode === ViewerMode.detailed) { //If detailed mode, wait for swiper and thumbnails in dom
        Promise.all([waitForElementToExist(this.renderRoot, '.swiper'), waitForElementToExist(this.renderRoot, '.swiper-thumbs')]).then(elements => {
          this.initSwiper();
        });
      }
      else { //If normal mode, only wait for swiper in dom
        waitForElementToExist(this.renderRoot, '.swiper').then(element => {
          this.initSwiper();
        });
      }
    }

    if (this.viewerMode === ViewerMode.normal) {
      if (changedProperties.get('isTileHover') === undefined) {
        return;
      }
      else {
        if (this.isTileHover) {
          this.swiper?.slideTo(1);
        }
        else {
          this.swiper?.slideTo(0);
        }
      }
    }

  }

  initSwiper(initialSlide: number = 0) {
    const htmlElement = this.renderRoot.querySelector('.swiper') as HTMLElement;
    const thumbsHtmlElement = this.renderRoot.querySelector('.swiper-thumbs') as HTMLElement;

    if (thumbsHtmlElement) {
      this.swiperThumbs = new Swiper(thumbsHtmlElement, {
        slidesPerView: 2,
        initialSlide: initialSlide,
      });
    }

    this.swiper = new Swiper(htmlElement, {
      loop: false,
      initialSlide: this.swiperActiveIndex,
      speed: 100,
      effect: 'fade',
      // effect: 'slide',
      fadeEffect: {
        crossFade: true
      },
      modules: [Navigation, Pagination, Thumbs, EffectFade],
      navigation: {
        enabled: true,
        nextEl: this.renderRoot.querySelector('.swiper-button-next') as HTMLElement,
        prevEl: this.renderRoot.querySelector('.swiper-button-prev') as HTMLElement,
      },
      thumbs: {
        swiper: this.swiperThumbs
      }
    });

    const self = this;
    this.swiper.on('slideChange', function (tmp) {
      self.swiperActiveIndex = tmp.activeIndex;
    })
  }

  render() {
    return html`
    <style>${mediaSliderCss}</style>
    <div class="media-wrapper ${this.viewerMode}">
      <div class="swiper">
        <div class="swiper-wrapper">
        ${this.currentColor?.productImages.slice(0, 2).map((productImage) => html`
          <div class="swiper-slide" style="background-image: url('${productImage.imageUrl}');"></div>
          </div>
        `)}
        </div>
        ${this.viewerMode === ViewerMode.detailed ? html`
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>` : ''}
      </div>
      ${this.viewerMode === ViewerMode.detailed ? html`
      <div class="swiper-thumbs-wrapper">
        <div class="swiper-thumbs">
          <div class="swiper-wrapper">
            ${this.currentColor?.productImages.slice(0, 2).map((productImage) => html`
              <div class="swiper-slide" style="background-image: url('${productImage.thumbImageUrl}');"></div>
              </div>
            `)}
          </div>
        </div>
      </div>` : ''}
    </div>
    `;
  }
}
